<template>



    <div>
        <a>{{ $t("titles.report") }}</a>
     
    </div>





</template>
<script>
    export default {
        name: "Online_monitoring"
    }
</script>

<style scoped>

</style> 


// WEBPACK FOOTER //
// src/pages/Online_monitoring.vue